import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const VariantSelector: StyleRule = () => ({
    maxWidth: pxToRem(896),

    [`&:empty`]: {
        display: 'none',
    },
});
